import React, { useEffect, useState } from "react";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { ToggleLeft, ToggleRight, SlidersHorizontal } from "lucide-react";

const MerchantFeatureAccess = ({ merchantId }) => {
  const [data, setData] = useState(null);
  const [savingKey, setSavingKey] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/admin/merchants/${merchantId}/features`).then((r) => setData(r.data)).catch((e) => toast.error(arabicError(e)));
  }, [merchantId]);

  const toggle = async (key) => {
    const next = !data.features[key];
    setSavingKey(key);
    try {
      const r = await api.put(`/admin/merchants/${merchantId}/features`, { features: { [key]: next } });
      setData((d) => ({ ...d, features: r.data.features }));
      toast.success(next ? `تم تفعيل: ${data.labels[key]}` : `تم إيقاف: ${data.labels[key]}`);
    } catch (e) { toast.error(arabicError(e)); }
    finally { setSavingKey(null); }
  };

  return (
    <div className="bg-white border border-[#7AB2B2] rounded-xl p-4 space-y-3" data-testid="merchant-feature-access">
      <div className="flex items-center gap-2">
        <SlidersHorizontal size={18} className="text-[#09637E]" />
        <h4 className="font-extrabold text-[#333333]">إدارة الميزات</h4>
        <span className="text-xs text-[#666666]">— خاصة بهذا التاجر فقط</span>
      </div>
      {!data ? <div className="text-sm text-[#666666]">جارٍ التحميل...</div> : (
        <ul className="divide-y divide-[#EBF4F6]">
          {Object.entries(data.labels).map(([key, label]) => {
            const on = data.features[key] !== false;
            return (
              <li key={key} className="py-2.5 flex items-center justify-between gap-3" data-testid={`feature-row-${key}`}>
                <div className="min-w-0">
                  <div className="text-sm font-bold text-[#333333]">{label}</div>
                  <div className={`text-xs font-extrabold ${on ? "text-green-700" : "text-red-600"}`} data-testid={`feature-status-${key}`}>
                    {on ? "مفعّلة" : "موقوفة"}
                  </div>
                </div>
                <button onClick={() => toggle(key)} disabled={savingKey === key} data-testid={`feature-toggle-${key}`}
                  aria-pressed={on} aria-label={`${on ? "إيقاف" : "تفعيل"} ${label}`}
                  className={`h-10 px-3 rounded-lg font-bold text-xs flex items-center gap-1 shrink-0 disabled:opacity-60 ${on ? "bg-green-600 hover:bg-green-700 text-white" : "border-2 border-[#7AB2B2] text-[#666666] hover:bg-[#EBF4F6]"}`}>
                  {on ? <ToggleRight size={20} /> : <ToggleLeft size={20} />}
                  {savingKey === key ? "..." : on ? "مفعّلة" : "موقوفة"}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default MerchantFeatureAccess;
